import { useLocation } from 'react-router'

export function useQueryParam(param: string) {
  const { search } = useLocation()
  const queryParams = new URLSearchParams(search)
  return queryParams.get(param)
}
